import Axios from "axios";

const axios = Axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  timeout: 60000,
});

axios.defaults.headers.common["Accept-Language"] = "tr-TR";

if (process.env.REACT_APP_MODE !== "production") {
  axios.defaults.headers.common["Authorization"] =
    "Basic dGVzdHVzZXI6WDJGQ3dXYmY=";
}

export default axios;
